import {
  type Message as LoginMessage,
  criticalMessages,
  positiveMessages,
  errorMessages,
  type ErrorObj,
} from '../components/pages/LoginPage/LoginForm/LoginMessage/types';

import arrayIncludes from './arrayIncludes';

export default (input: string): LoginMessage | null => {
  const messageKey = input?.includes('error.')
    ? (input as LoginMessage)
    : (`login_msg.${input}` as LoginMessage);
  return arrayIncludes<LoginMessage>(messageKey, [
    ...criticalMessages,
    ...positiveMessages,
    ...errorMessages,
  ])
    ? messageKey
    : null;
};

export const getErrorCode = (error: string): ErrorObj => {
  const internalErrorCode = 'error.internal';
  if (error.includes(`${internalErrorCode}.`)) {
    const [, errorSubCode] = error.split(`${internalErrorCode}.`);
    return { errorCode: internalErrorCode, errorSubCode };
  }
  return { errorCode: error };
};
